import React from 'react';
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppState } from 'store'

import Summary from 'components/Summary/Summary'
import { numberToDisplayString } from 'common/helpers/numberHelpers'
import Button, { AppButtonTypes } from 'components/Buttons/ButtonBase/Button'
import ButtonCancelApplication from 'components/Buttons/ButtonCancelApplication/ButtonCancelApplication'
import { AppLinks } from 'enviroment/AppLinks'
import FullOffertInfoMenu from 'components/FullOffertInfoMenu/FullOffertInfoMenu'
import { FULL_OFFERT_MENU_TYPES } from 'components/FullOffertInfoMenu/FullOffertInfoMenuProps'
import useTextContents from 'common/hooks/useTextContents'
import PageVerticalContentStepper from 'components/PageVerticalContentStepper/PageVerticalContentStepper'
import { IPaymentDetailsShortChangeInstalmentsProps, IPaymentDetailsStepperStepOneProps } from './ProductProps'
import ChangeInstalmentsMenu from 'components/ChangeInstalmentsMenu/ChangeInstalmentsMenu'
import { WorkflowTypes } from 'common/workflow'
import { isTrastiBroker } from 'common/helpers/helpers'
import TrastiProductPageContent from './TrastiProductPage'

import './ProductStyles.scss'


const PaymentDetailsShortChangeInstalments = (props: IPaymentDetailsShortChangeInstalmentsProps) => {

  const { pageDetailsTextContents, instalmentNumber, instalmentAmount } = props

  return (
    <div className='payment-details-short-change-instalments-wrapper'>
      <p>
        {pageDetailsTextContents('productPage.afterInitialPeriodText')} <b>{`${instalmentNumber} x ${numberToDisplayString(instalmentAmount, " zł")}`}</b>
        <FullOffertInfoMenu menuType={FULL_OFFERT_MENU_TYPES.INFO} />
      </p>
      <ChangeInstalmentsMenu />
    </div>
  )
}


const PaymentDetailsStepperStepOne = (props: IPaymentDetailsStepperStepOneProps) => {

   const { pageDetailsTextContents, amountToPay } = props
 
   return (
      <>
         {pageDetailsTextContents('productPage.stepperStage1.part1')} <br /> 
         <span className='payment-step-short-content-one-info-icon-wrapper'>
            {pageDetailsTextContents('productPage.stepperStage1.part2')} <b>{numberToDisplayString(amountToPay, ' zł')}</b>
            <FullOffertInfoMenu menuType={FULL_OFFERT_MENU_TYPES.INFO} />
         </span>
      </>
   )
}


/**
 * Główny content komponentu
 * @returns 
 */
const ProductPageContent = () => {
  const pageDetailsTextContents = useTextContents()
  const applicationState = useSelector((state: AppState) => state.applicationState)
  const currentSelectedInstallmentsNumber = applicationState.offert.paymentSchedule.filter(singlePaymentSchedule => singlePaymentSchedule.isSelected).length
  const navigate = useNavigate()

  
  const handleOnNavigationButtonClick = () => {
   if(WorkflowTypes.IsRetention(applicationState.workflowId)){
     navigate(AppLinks.retention)
   }
   else if (WorkflowTypes.isNormal(applicationState.workflowId)) {
     navigate(AppLinks.chooseIdentityMethod)
   }
 }
  
  return (
    <section className='payment-details-short-outer-section-wrapper'>
      <h1 className='payment-detail-header'>{pageDetailsTextContents('productPage.header')}</h1>
      <PageVerticalContentStepper 
         StepOneContentElement={() => <PaymentDetailsStepperStepOne amountToPay={applicationState.amountToPay} pageDetailsTextContents={pageDetailsTextContents} />}
         StepTwoContentElement={() => (<>{pageDetailsTextContents('productPage.stepperStage2')}</>)}
      />
      <PaymentDetailsShortChangeInstalments 
         instalmentAmount={applicationState.offert.instalmentAmount} 
         instalmentNumber={currentSelectedInstallmentsNumber} 
         pageDetailsTextContents={pageDetailsTextContents} 
      />
      <Button 
         uiButtonType={AppButtonTypes.PRIMARY} 
         buttonContent={pageDetailsTextContents('buttons.next')} 
         className='payment-detail-short-submit-button page-main-button-submission-button' 
         onClick={() => handleOnNavigationButtonClick()} 
      />
      <ButtonCancelApplication />
    </section>
  )
}

/**
 * Komponent obsługujący stronę "Dopasuj produkt"
*/
const ProductPage = (): JSX.Element => {
   if (isTrastiBroker()){
      return (
         <div className='product-page-main-wrapper'>
            <TrastiProductPageContent />
            <Summary isExtended={true} />
         </div>
      )
   }
   else {
      return (
         <div className='product-page-main-wrapper'>
            <ProductPageContent /> 
            <Summary />
         </div>
      )
   }
}

export default ProductPage